<template>
  <div>
    <v-row>
      <v-col>
        <UserWelcomeent />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="7">
        <DashboardWelcomeCard />
        <DashboardChecklistCard />
        <DashboardSessionStats />
        <DashboardNextSessions />
        <DashboardPendingCustomers />
        <DashboardBirthdays />
      </v-col>
      <v-col cols="12" md="5">
        <DashboardCommunityCard />
        <DashboardSmartFeatures />
        <DashboardSupportCard />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DashboardSessionStats from "../components/dashboard/sections/DashboardSessionStats.vue";
import UserWelcomeent from "../components/dashboard/sections/UserWelcomeent.vue";
import DashboardWelcomeCard from "@/components/dashboard/sections/DashboardWelcomeCard.vue";
import DashboardChecklistCard from "@/components/dashboard/sections/DashboardChecklistCard.vue";
import DashboardSmartFeatures from "@/components/dashboard/sections/DashboardSmartFeatures.vue";
import DashboardCommunityCard from "@/components/dashboard/sections/DashboardCommunityCard.vue";
import DashboardSupportCard from "@/components/dashboard/sections/DashboardSupportCard.vue";
import DashboardBirthdays from "@/components/dashboard/sections/DashboardBirthdays.vue";
import DashboardNextSessions from "@/components/dashboard/sections/DashboardNextSessions.vue";
import DashboardPendingCustomers from "@/components/dashboard/sections/DashboardPendingCustomers.vue";


export default {
  components: {
    DashboardNextSessions,
    DashboardSessionStats,
    DashboardBirthdays,
    DashboardPendingCustomers,
    DashboardWelcomeCard,
    DashboardChecklistCard,
    DashboardSmartFeatures,
    DashboardCommunityCard,
    DashboardSupportCard,
    UserWelcomeent,
  },
};
</script>
